import { APIClient } from "./api";
import { CHANGE_PASSWORD_URL,ALL_PREFERENCES, USERUPDATE,USERUPDATE1, FIND_ALL_GOALS, FIND_ALL_MEALPLANS, FIND_ALL_RECIPES, LOGIN, REGISTER, USER, VERIFY_EMAIL, VERIFY_OTP, WORKOUTBYUSER,CATEGORY_SPORT,FIND_HEIGHT_USER } from "./url_helper";
import axios from "axios";
//import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};



// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const register = data => api.create(REGISTER, data);
export const verifyOTP = data => api.create(`${VERIFY_OTP+data}`, data);

// reset password
export const VerifyEmail = data => api.create(VERIFY_EMAIL, data);
export const changePasswordRequest = async (data, headers) => {
  console.log("Données envoyées pour le changement de mot de passe:", data);
  return api.update(CHANGE_PASSWORD_URL, data, { headers });
};

// Login Method
export const login = data => api.create(LOGIN, data);

export const GetAllGoals = () => api.get(FIND_ALL_GOALS);


// diet
export const GetDiet = () => api.get(FIND_ALL_RECIPES);

export const postHeightUserUrl = (weight) =>
  api.post(`${FIND_HEIGHT_USER}?weight=${weight}`);

export const GetMealPlans = () => api.get(FIND_ALL_MEALPLANS);

// Fonction pour appeler l'API
export const GenerateMealPlan = (userId, body) => {
  return api.post(`/usersApi/api/alimentary/mealPlan/generate-meal-plan?userId=${userId}`, body);
};


export const GetMealPlansByUser = (userId) => api.get(`/usersApi/api/alimentary/mealPlan/get-user-mealPlans/${userId}`);

// Appel API pour mettre à jour une recette/préférence
export const updateRecipe = (updateData, recipeId, userId) => {
  return api.post(
    `usersApi/api/alimentary/recipes/change/recipe?recipeId=${recipeId}&userId=${userId}`,
    updateData
  );
};
// Fonction pour ajouter une activitéexport const addActivityApi = (userId, activity) =>
export const addActivityApi = (userId, activity) =>
api.post(`usersApi/api/alimentary/mealPlan/update-after-activity/?userId=${userId}`, activity, {
  headers: {
    "accept": "application/hal+json",
    "Content-Type": "application/json",
  },
});

export const GetMealPlansforDashboard = (dailyMealID) => api.get(`/usersApi/api/logs/log-Meal-Consumption/${dailyMealID}`);



export const GetAllPreferences = () => api.get(ALL_PREFERENCES);

export const GetUser = data => api.get(`${USER+data}`);
export const updateUser = (userData) => {
  return api.put(`${USERUPDATE}`, userData);
};
export const updateUser1 = (userId, userData) => {
  return api.put(`${USERUPDATE1}?userId=${userId}`, userData);
};




// sport
export const GetWorkoutByUserId = data => api.get(`${WORKOUTBYUSER+data}`);

export const GetSportCategories = data => api.get(`${CATEGORY_SPORT}`);

// services/activityService.js
export const SearchActivities = (keyword) => {
  return api.get(`/usersApi/api/activity/search?keyword=${keyword}`);
};


// Dans votre fichier de services (ex: services/userServices.js)
export const SearchFoodPreferences = (keyword) => {
  return api.get(`/usersApi/api/users/preferences/search?keyword=${keyword}`);
};

const API_BASE_URL = "http://95.111.225.198:8082/usersApi";
export const changePassword = async (values) => {
  try {
    const authUser = sessionStorage.getItem("authUser"); // Récupère la valeur sous forme de chaîne JSON
    const token = authUser ? JSON.parse(authUser).data.token : null; // Parse et extrait le token

    const headers = {
      "Authorization": token ? `Bearer ${token}` : "", // Ajoute le token uniquement s'il existe
      "Content-Type": "application/json",
      "Accept": "application/hal+json"
    };

    const response = await axios.patch(
      `${API_BASE_URL}/api/users/change-password`,
      values,
      { headers } // Passe directement l'objet headers ici
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
